/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AvailableUpdateUpgradeResponseDtoLatestUpdateInfo } from './AvailableUpdateUpgradeResponseDtoLatestUpdateInfo';
import {
    AvailableUpdateUpgradeResponseDtoLatestUpdateInfoFromJSON,
    AvailableUpdateUpgradeResponseDtoLatestUpdateInfoFromJSONTyped,
    AvailableUpdateUpgradeResponseDtoLatestUpdateInfoToJSON,
} from './AvailableUpdateUpgradeResponseDtoLatestUpdateInfo';

/**
 * 
 * @export
 * @interface AvailableUpdateUpgradeResponseDto
 */
export interface AvailableUpdateUpgradeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AvailableUpdateUpgradeResponseDto
     */
    installedVersion?: string | null;
    /**
     * 
     * @type {AvailableUpdateUpgradeResponseDtoLatestUpdateInfo}
     * @memberof AvailableUpdateUpgradeResponseDto
     */
    latestUpdateInfo?: AvailableUpdateUpgradeResponseDtoLatestUpdateInfo | null;
    /**
     * 
     * @type {AvailableUpdateUpgradeResponseDtoLatestUpdateInfo}
     * @memberof AvailableUpdateUpgradeResponseDto
     */
    latestUpgradeInfo?: AvailableUpdateUpgradeResponseDtoLatestUpdateInfo | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableUpdateUpgradeResponseDto
     */
    $type?: AvailableUpdateUpgradeResponseDtoTypeEnum;
}


/**
 * @export
 */
export const AvailableUpdateUpgradeResponseDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCsoPortalDtoAvailableUpdateUpgradeResponseDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.CsoPortal.Dto.AvailableUpdateUpgradeResponseDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type AvailableUpdateUpgradeResponseDtoTypeEnum = typeof AvailableUpdateUpgradeResponseDtoTypeEnum[keyof typeof AvailableUpdateUpgradeResponseDtoTypeEnum];



/**
 * Check if a given object implements the AvailableUpdateUpgradeResponseDto interface.
 */
export function instanceOfAvailableUpdateUpgradeResponseDto(value?: unknown): value is AvailableUpdateUpgradeResponseDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(AvailableUpdateUpgradeResponseDtoTypeEnum)[0];
}

export function AvailableUpdateUpgradeResponseDtoFromJSON(json: any): AvailableUpdateUpgradeResponseDto {
    return AvailableUpdateUpgradeResponseDtoFromJSONTyped(json, false);
}

export function AvailableUpdateUpgradeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableUpdateUpgradeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'installedVersion': json['installedVersion'] == null ? undefined : json['installedVersion'],
        'latestUpdateInfo': json['latestUpdateInfo'] == null ? undefined : AvailableUpdateUpgradeResponseDtoLatestUpdateInfoFromJSON(json['latestUpdateInfo']),
        'latestUpgradeInfo': json['latestUpgradeInfo'] == null ? undefined : AvailableUpdateUpgradeResponseDtoLatestUpdateInfoFromJSON(json['latestUpgradeInfo']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function AvailableUpdateUpgradeResponseDtoToJSON(value?: AvailableUpdateUpgradeResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'installedVersion': value['installedVersion'],
        'latestUpdateInfo': AvailableUpdateUpgradeResponseDtoLatestUpdateInfoToJSON(value['latestUpdateInfo']),
        'latestUpgradeInfo': AvailableUpdateUpgradeResponseDtoLatestUpdateInfoToJSON(value['latestUpgradeInfo']),
        '$type': value['$type'],
    });
}

